import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBiking, faReply, faWalking } from '@fortawesome/free-solid-svg-icons';
import { loadModules } from 'esri-loader';
import Cookies from 'js-cookie';

import API_PATH from "../../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& > *': {
      margin: theme.spacing(1),
      width: '98%',
    },
  },
  rootBox: {
    flexGrow: 1,
  },
  paper: {
    width: '100%',
    boxShadow: 'none',
    padding: "5px"
  },
  container: {
    width: '500px',
    float: 'left',
    background: '#fff',
    borderRadius: '5px',
    height: '87vh',
    padding: '0px',
    border: '1px solid #24618E',
    borderRadius: '5px',
    position: "relative",
    zIndex: 99999
  },
  intersection: {
    top: '120px',
    width: '500px',
    height: 'auto',
    position: 'fixed',
    background: '#fff',
    left: '10px',
    zIndex: '999',
    border: '1px solid #00A75D',
    borderRadius: '5px'
  },
  formHead: {
    padding: '15px 15px 15px 15px',
    '& h3': {
      color: '#24618E',
      fontSize: '25px',
      marginTop: '0px',
      marginBottom: '-10px',
    },
    '& img': {
      width: '100%',
      height: '2px',
    }
  },
  teamsUl: {
    paddingLeft: '5px !important',
    paddingTop: 0,
    '& li': {
      listStyle: 'none',
      float: 'left',
      textAlign: 'center',
      marginLeft: '50px'
    },
  },
  btnIcon: {
    color: '#24618E',
    marginRight: '5px',
    // cursor: 'pointer',
  },
  fieldsetname: {
    width: 'auto',
    border: '1px solid rgba(0, 167, 93, 1)',
    margin: '10px',
    padding: '10px',
    borderRadius: '5px',
  },
  simpleBtn: {
    marginTop: '0px',
    border: '1px solid #333',
    color: '#333',
    background: '#fff !important',
    fontSize: '12px',
    width: '110px',
  },
  floatLeftBtn: {
    float: 'left',
  },
  floatRightBtn: {
    float: 'right'
  },
  floatCenterBtn: {
    clear: 'both'
  },
  tableHead: {
    fontWeight: 'bolder',
    fontSize: '18px',
    textAlign: 'center',
    padding: 0
  },
  titleTD: {
    textAlign: 'left',
    fontSize: '18px',
    padding: 0
  },
  dataTD: {
    textAlign: 'center',
    fontSize: '18px',
    padding: 0
  },
  mainbtnDiv: {
    border: '1px solid #24618E',
    borderTop: 'none',
    borderRadius: '0px 0px 5px 5px',
    minHeight: '365px',
    '& .focusBtn': {
      color: "#fff",
      background: '#24618E',
    }
  },
  mapContainer: {
    width: '100% !important',
    height: '75vh !important',
    display: 'block !important',
    '& .esri-view-root': {
      height: '100% !important',
      width: '100% !important'
    }
  },
}));
//End Css code ...

let latitude;
let longitude;

//Start IntersectionLocationDetails component code ...
const IntersectionLocationDetails = props => {
  const [spacing, setSpacing] = React.useState(2);
  const classes = useStyles();
  const mapRef = useRef();
  const [stationDetails, setStationDetails] = React.useState({});

  const [turningCountDate, setTurningCountDate] = React.useState();
  const [pedestrianCountDate, setPedestrianCountDate] = React.useState();
  const [biCycleCountDate, setBiCycleCountDate] = React.useState();


  useEffect(() => {
    if (props.stationId) {
      loadMap();
      getStationRecentYear();
    }
  }, [props.stationId]);

  //This method is use for map .... start
  const loadMap = () => {
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic", "esri/layers/GraphicsLayer", "esri/symbols/PictureMarkerSymbol", "esri/widgets/Search"], { css: true })
      .then(async ([ArcGISMap, MapView, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, GraphicsLayer, PictureMarkerSymbol, Search]) => {
        const map = new ArcGISMap({
          basemap: 'topo-vector',
          slider: false
        });

        let view = new MapView({
          container: mapRef.current,
          map: map,
          ui: {
            components: ['home', 'locate'] // specify only the components you want
          },
        });
        let featureLayer = new FeatureLayer({
          url: sessionStorage.getItem('mapURL')
        });
        featureLayer.when(function () { // adds feature layer to map view
          let vp = new Viewpoint({
            targetGeometry: featureLayer.fullExtent
          });
          view.extent = featureLayer.fullExtent;

        });
        map.add(featureLayer);
        let position = await getStationDetails();
        featureLayer.when(async function () { // adds feature layer to map view         
          // console.log('Logn :'+longitude+ 'Lat :'+latitude);
          let point = new Point(position.longitude, position.latitude);
          let pointSymbol = {
            type: "simple-marker",
            style: "circle",
            color: "#00A75D",
            size: 20,
            outline: {
              color: "#24618e",
              width: 0.5
            }
          }
          let pointGraphic = new Graphic(point, pointSymbol);
          view.graphics.add(pointGraphic);
          view.goTo(pointGraphic).then(function () {
            view.zoom = view.zoom + 5;
          });
        });

      });
  }
//This method is use for map .... end


  //This method is use for get sation details .... start
  const getStationDetails = () => {
    try {
      return axios({
        method: 'get',
        url: API_URL + API_PATH.getStationDetail + props.stationId,
      })
        .then(function (response) {
          if (response && response.data.data) {
            setStationDetails(response.data.data);
            return {
              latitude: response.data.data.latitude,
              longitude: response.data.data.longitude
            }
          }
          else {
            console.log('');
          }

        })
        .catch(function (error) {
          console.log(error);
        })
    } catch (error) {
      console.error(error);
    }
  }
//This method is use for get sation details .... start


  //This method is use for get station recent year data .... start
  const getStationRecentYear = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getStationRecentYear,
        data: {
          stationId: props.stationId
        }
      }).then(function (response) {
        if (response && response.data.data) {
          setTurningCountDate(response.data.data.turningyear);
          setPedestrianCountDate(response.data.data.pedestrianyear);
          setBiCycleCountDate(response.data.data.bicycleyear);
        } else {
          // Data Not Found
        }
      })
    }
    catch (error) {
      // Throw error;
    }
  }
  //This method is use for get station recent year data .... end

  return (
    <React.Fragment>
      <CssBaseline />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <fieldset className={classes.fieldsetname} style={{ paddingTop: 0, marginRight: 0 }}>
            <legend>Most Recent Data Types</legend>
            <Grid container className={classes.rootBox} spacing={spacing}>
              <Grid item xs={12}>
                <Grid container justify="center" spacing={spacing}>
                  <Grid xs={12} item>
                    <Paper className={classes.paper} >
                      {
                        (turningCountDate || pedestrianCountDate || biCycleCountDate) ?
                          <ul className={classes.teamsUl}>
                            {
                              turningCountDate ?
                                <li style={{ marginLeft: '0px', marginRight: '50px' }} title='Turning Movement'>
                                  <FontAwesomeIcon icon={faReply} className={classes.btnIcon} /> <br />
                                  {turningCountDate}
                                </li> : null
                            }
                            {
                              pedestrianCountDate ?
                                <li style={{ marginLeft: '0px', marginRight: '50px' }} title='Pedestrian'>
                                  <FontAwesomeIcon icon={faWalking} className={classes.btnIcon} /> <br />
                                  {pedestrianCountDate}
                                </li> : null
                            }
                            {
                              biCycleCountDate ?
                                <li style={{ marginLeft: '0px' }} title='Bicycle'>
                                  <FontAwesomeIcon icon={faBiking} className={classes.btnIcon} /> <br />
                                  {biCycleCountDate}
                                </li> : null
                            }
                          </ul> : <p style={{ textAlign: 'center' }}>  No data has been imported for this station  </p>
                      }
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </fieldset>
          <fieldset className={classes.fieldsetname} style={{ marginRight: 0 }}>
            <legend>Details</legend>
            <Grid container className={classes.rootBox} spacing={spacing}>
              <Grid item xs={12}>
                <Grid container justify="center" spacing={spacing}>
                  <Grid xs={12} item>
                    <Paper className={classes.paper} >
                      <span style={{ textTransform: 'capitalize' }}>
                        Status: {stationDetails.status ? stationDetails.status : null}
                      </span> <br/>                     
                      <span>                       
                        Jurisdiction: {stationDetails.Jurisdiction_name ? stationDetails.Jurisdiction_name : <span>N/A</span>}
                      </span> <br />
                      <span>
                        County: {stationDetails.fips_county_code ? stationDetails.fips_county_code : <span>N/A</span>}
                      </span> <br />
                      <span>                        
                        Community: {stationDetails.community ? stationDetails.community : <span>N/A</span>}
                      </span> <br />
                      <span> Lat / Long: {stationDetails.latitude ? parseFloat(stationDetails.latitude).toFixed(5) + ' , ' : null} {stationDetails.longitude ? parseFloat(stationDetails.longitude).toFixed(5) : null} </span> <br />
                      <span> Description: {stationDetails.description ? stationDetails.description : <span>N/A</span>} </span> <br />
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </fieldset>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div ref={mapRef} className={classes.mapContainer} data-testid='mapView'
            style={{ border: "1px solid #24618e" }}>
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default IntersectionLocationDetails;
//Start IntersectionLocationDetails component code ...